interface OptionGridProps<T extends string> {
  options: readonly T[];
  selected: T | null;
  onSelect: (value: T) => void;
  label: string;
}

export function OptionGrid<T extends string>({
  options,
  selected,
  onSelect,
  label,
}: OptionGridProps<T>) {
  return (
    <div role="radiogroup" aria-label={label} className="grid grid-cols-2 gap-4 w-full max-w-md">
      {options.map((option) => {
        const isSelected = selected === option;
        return (
          <button
            key={option}
            type="button"
            role="radio"
            aria-checked={isSelected}
            onClick={() => onSelect(option)}
            className={`min-h-[44px] px-4 py-4 rounded-xl border text-center font-['DM_Sans',sans-serif] text-base text-white transition-all ${
              isSelected ? 'border-[#f97216]' : 'border-[var(--gray-border)] hover:border-gray-400'
            }`}
            style={
              isSelected
                ? {
                    backgroundImage: 'var(--brand-gradient-60)',
                    boxShadow: 'var(--orange-glow)',
                  }
                : {
                    backgroundImage: 'var(--glass-gradient)',
                  }
            }
          >
            {option}
          </button>
        );
      })}
    </div>
  );
}
